// Review rows for the "Review future slots" step, in display order.
// removable false means the run never deletes that status; the row offers
// only the create overlapping toggle.
// color matches the slot status palette used by the booking views.
export const FUTURE_SLOT_STATUSES = [
  { status: 'booked', label: 'Booked', removable: false, color: '#1D8CF8' },
  { status: 'requested', label: 'Requested', removable: false, color: '#00D6B4' },
  { status: 'requestable', label: 'Requestable', removable: true, color: '#FFD600' },
  { status: 'call_to_book', label: 'Call to book', removable: true, color: '#FB6340' },
  { status: 'blocked', label: 'Blocked', removable: true, color: '#D44872' },
  { status: 'custom_status', label: 'Custom status', removable: true, color: '#8B8FA8' }
]

export const SKIP_MODE_OPTIONS = [
  { value: 'none', label: 'Create all' },
  { value: 'start', label: 'Skip on start match' },
  { value: 'exact', label: 'Skip on exact match' }
]

// body is the parsed check-future-slots response
export function buildFutureSlotRows(body) {
  const counts = body || {}
  return FUTURE_SLOT_STATUSES.map(def => ({
    ...def,
    count: Number(counts[def.status]) || 0,
    remove: false,
    create_overlap: false,
    skip_mode: 'none'
  }))
}

export function hasFutureSlotConflicts(body) {
  return buildFutureSlotRows(body).some(r => r.count > 0)
}

// Flat request fields every schedule run endpoint reads
export function buildFutureSlotFlags(rows) {
  const byStatus = Object.fromEntries((rows || []).map(r => [r.status, r]))
  const row = s => byStatus[s] || { remove: false, create_overlap: false, skip_mode: 'none' }
  const exact = r => !!(r.create_overlap && r.skip_mode === 'exact')
  const start = r => !!(r.create_overlap && r.skip_mode === 'start')
  const booked = row('booked')
  const requested = row('requested')
  const requestable = row('requestable')
  const ctb = row('call_to_book')
  const blocked = row('blocked')
  const custom = row('custom_status')
  return {
    remove_call_to_book: !!ctb.remove,
    remove_block: !!blocked.remove,
    remove_custom_status: !!custom.remove,
    remove_requestable: !!requestable.remove,
    create_overlap_on_booked_slots: !!booked.create_overlap,
    create_overlap_requested: !!requested.create_overlap,
    create_overlap_requestable: !!requestable.create_overlap,
    create_overlap_call_to_book: !!ctb.create_overlap,
    create_overlap_block: !!blocked.create_overlap,
    create_overlap_custom_status: !!custom.create_overlap,
    skip_exact_match: exact(booked),
    skip_exact_match_requested: exact(requested),
    skip_exact_match_requestable: exact(requestable),
    skip_exact_match_call_to_book: exact(ctb),
    skip_exact_match_blocked: exact(blocked),
    skip_exact_match_custom_status: exact(custom),
    skip_start_match: start(booked),
    skip_start_match_requested: start(requested),
    skip_start_match_requestable: start(requestable),
    skip_start_match_call_to_book: start(ctb),
    skip_start_match_blocked: start(blocked),
    skip_start_match_custom_status: start(custom)
  }
}
